import Polygon from '@arcgis/core/geometry/Polygon';

export function getAreaAsCqlQueryString(asPolygon: Polygon) {
    const multipolygonPartsString = asPolygon.rings.reduce((prev, curr) => {
        const multipolygonStart = "((";

        let cqlPolygonString = curr.reduce((prev2, curr2) => {
            return prev2 + `${curr2[0]} ${curr2[1]},`;
        }, "");

        cqlPolygonString = cqlPolygonString.substring(0, cqlPolygonString.length - 1);

        const multipolygonEnd = "))";

        let toReturn = "";

        if (prev !== "") {
            toReturn += ",";
        }

        return prev + toReturn + multipolygonStart + cqlPolygonString + multipolygonEnd;
    }, "");

    let cqlPolygonString = "WITHIN(GEOMETRY, SRID=4326;MULTIPOLYGON(" + multipolygonPartsString;

    cqlPolygonString = cqlPolygonString.substring(0, cqlPolygonString.length - 1);
    cqlPolygonString = cqlPolygonString + ")))";
    return cqlPolygonString;
}
